import { Injectable } from '@angular/core';
import { IListService } from '@captiveaire/advanceddropdown';
import { QueryService } from '@captiveaire/query';
import { IGridPagedResult } from '@caslink/common-client';
import { IQuery } from '@captiveaire/query';
import { ProxyService } from '@caslink/common-client/ng-app/proxy/ProxyService';

// tslint:disable-next-line: no-empty-interface
export interface ISensorCategoryTypeSearchCriteria extends IQuery {
}


export interface ISensorCategoryTypeSummary {
    id: string;
    type: string;
}


@Injectable({
    providedIn: 'root'
})
export class SensorCategoryTypeService implements IListService {
    public static $name: string = 'sensorCategoryTypeService';

    constructor(
        private queryService: QueryService,
        private proxyService: ProxyService
    ) {
    }

    public getList(query: ISensorCategoryTypeSearchCriteria):
        angular.IPromise<IGridPagedResult<ISensorCategoryTypeSummary>> {
        const sort = (query.ascending) ? 0 : 1;
        return this.proxyService.request({
            endPoint: 'sensorCategory',
            queryParams: {
                'searchCriteria.pagingCriteria.includeTotalCount': query.includeTotalCount,
                'searchCriteria.pagingCriteria.skip': (query.page - 1) * query.limit,
                'searchCriteria.pagingCriteria.sortDirection': sort,
                'searchCriteria.pagingCriteria.sortExpressions': [query.getOrderWithCapitalized()],
                'searchCriteria.pagingCriteria.take': query.limit,
                'searchCriteria.uniqueIdentifier': query.id,
                'searchCriteria.wildcard': query.wildcard
            },
            route: 'getSensorCategories'
        }
        ).as<IGridPagedResult<ISensorCategoryTypeSummary>>();
    }

    /* Not implemented */
    public getEndpointName() {
        return 'sensor-category-type-update-context';
    }

    public getCategory(category: string): angular.IPromise<ISensorCategoryTypeSummary> {
        return this.proxyService.request({
            endPoint: 'sensorCategory',
            route: 'getSensorCategory',
            routeParams: {
                type: category
            }
        }
        ).as<ISensorCategoryTypeSummary>();
    }

    public getListItem(id: string):
        angular.IPromise<IGridPagedResult<ISensorCategoryTypeSummary>> {
        const query = this.queryService.createQuery(1, 'Id', 1, true);
        query.id = id;
        return this.getList(query);
    }
}
